import React from 'react';
import { Modal, Collapse, Button } from 'antd';
import { QuestionCircleOutlined, MailOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

const FaqModal = ({ faqVisible, setFaqVisible, setContactUsVisible }) => {
  const faqItems = [
    {
      key: '1',
      question: 'How do I get nearby queue details?',
      answer: 'When you open the app, you need to allow location services. Based on your location, we will display the relevant queue information.',
    },
    {
      key: '2',
      question: 'How do I get queue details for businesses far from my current location?',
      answer: 'If you want information about businesses at a different location, you can update your current location by clicking on the location details in the header or by adjusting the search radius.',
    },
    {
      key: '3',
      question: 'How do I find queue details for a business that isn\'t showing in the list?',
      answer: 'Try searching for the business name in the search bar. If found, you can add it to your favorites by clicking the star icon.',
    },
    {
      key: '4',
      question: 'Can I set my preferred business to appear at the top so I don\'t need to search for it?',
      answer: 'Yes, you can! Each business card has a star icon. Click it to add the business to your favorites. Then enable the favorites toggle to always see your preferred businesses at the top of the list.',
    }
  ];;

  return (
    <Modal
      title={
        <span>
          <QuestionCircleOutlined style={{ marginRight: 8 }} />
          Frequently Asked Questions
        </span>
      }
      visible={faqVisible}
      onCancel={()=>setFaqVisible(false)}
      footer={null}
      width={700}
    >
      <div style={{ marginTop: 24 }}>
        <Collapse accordion>
          {faqItems.map((item) => (
            <Panel header={item.question} key={item.key}>
              <p>{item.answer}</p>
            </Panel>
          ))}
        </Collapse>
        
        <div style={{ marginTop: 24, textAlign: 'center' }}>
          <p>Didn't find what you're looking for?</p>
          <Button 
            type="primary" 
            icon={<MailOutlined />}
            onClick={()=>{setContactUsVisible(true); setFaqVisible(false)}}
          >
            Contact our support team
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default FaqModal;